// src/DoctorListSEO.jsx
import React from "react";

export default function DoctorListSEO({
  doctors = [],
  pageUrl = "https://www.mikdok.com/",
}) {
  const siteUrl = "https://www.mikdok.com";

  const itemListElement = doctors.map((d, idx) => {
    const url = `${siteUrl}/doctor/${d.slug || d.id}`;
    const physician = {
      "@type": "Physician",
      "@id": url,
      "name": d.name,
      "url": url,
      "image": d.photoURL || d.image,
      "medicalSpecialty": d.specialty,
      "address": d.city
        ? {
            "@type": "PostalAddress",
            "addressLocality": d.city,
          }
        : undefined,
      "aggregateRating":
        d.rating && d.reviewCount
          ? {
              "@type": "AggregateRating",
              "ratingValue": d.rating,
              "reviewCount": d.reviewCount,
            }
          : undefined,
      "knowsAbout":
        d.verified || d.isVerified
          ? ["MikDok Verified Doctor"]
          : undefined,
    };
    return {
      "@type": "ListItem",
      "position": idx + 1,
      "url": url,
      "item": physician,
    };
  });

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    "itemListOrder": "https://schema.org/ItemListOrderAscending",
    "itemListElement": itemListElement,
    "url": pageUrl,
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
    />
  );
}
